import './belege.css';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useClientApp } from '../context';
import { BelegSheet } from './BelegSheet';
import { FolderPage } from './FolderPage';
import { belegePath, isCategory } from './labels';
import { FirmsPage, FoldersPage, MonthsPage, YearsPage } from './Pages';

// Alle Seiten unter /app/belege: Firma → Jahr → Monat → Ordner. Ein Beleg öffnet sich als Fenster (?beleg=<id>).
export function BelegeRoutes() {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const belegId = params.get('beleg');

  const closeSheet = () => {
    // selbst geöffnet: zurück im Verlauf (so schließt auch die Zurück-Geste das Fenster), sonst nur die Adresse kürzen
    if ((location.state as { sheet?: boolean } | null)?.sheet) navigate(-1);
    else {
      const next = new URLSearchParams(params);
      next.delete('beleg');
      setParams(next, { replace: true });
    }
  };

  return (
    <>
      <Routes>
        <Route index element={<FirmsPage />} />
        <Route path=":clientId" element={<Level />} />
        <Route path=":clientId/:year" element={<Level />} />
        <Route path=":clientId/:year/:month" element={<Level />} />
        <Route path=":clientId/:year/:month/:category" element={<Level />} />
        <Route path="*" element={<Navigate to="/app/belege" replace />} />
      </Routes>
      {belegId && <BelegSheet key={belegId} id={belegId} onClose={closeSheet} />}
    </>
  );
}

// Prüft die Teile der Adresse und zeigt die passende Ebene
function Level() {
  const { clients } = useClientApp();
  const p = useParams();
  const clientId = p.clientId ?? '';
  if (!clients.some((c) => c.id === clientId)) return <Navigate to="/app/belege" replace />;
  if (p.year === undefined) return <YearsPage clientId={clientId} />;
  const year = Number(p.year);
  if (!Number.isInteger(year) || year < 2000 || year > 2100) return <Navigate to={belegePath(clientId)} replace />;
  if (p.month === undefined) return <MonthsPage clientId={clientId} year={year} />;
  const month = Number(p.month);
  if (!Number.isInteger(month) || month < 1 || month > 12) return <Navigate to={belegePath(clientId, year)} replace />;
  if (p.category === undefined) return <FoldersPage clientId={clientId} year={year} month={month} />;
  if (!isCategory(p.category)) return <Navigate to={belegePath(clientId, year, month)} replace />;
  return <FolderPage clientId={clientId} year={year} month={month} category={p.category} />;
}
